import './FlowerGrowthAnimation.css';

interface FlowerGrowthAnimationProps {
  stampCount: number;
  maxStamps?: number;
}

export default function FlowerGrowthAnimation({
  stampCount,
  maxStamps = 100
}: FlowerGrowthAnimationProps) {

  return (
    <div className="flower-animation-container">
      {/* 鳥のアニメーション */}
      <div className="bird bird-1">🕊️</div>
      <div className="bird bird-2">🕊️</div>
      <div className="bird bird-3">🕊️</div>

      {/* 桜の花びらのアニメーション */}
      <div className="sakura-petal sakura-1">🌸</div>
      <div className="sakura-petal sakura-2">🌸</div>
      <div className="sakura-petal sakura-3">🌸</div>
      <div className="sakura-petal sakura-4">🌸</div>
      <div className="sakura-petal sakura-5">🌸</div>
      <div className="sakura-petal sakura-6">🌸</div>

      <div className="growth-image-container">
        {stampCount > 0 ? (
          <img
            src={stampCount === 100 ? `/growth/growth_${stampCount}.gif` : `/growth/growth_${stampCount}.png`}
            alt={`成長ステージ ${stampCount}`}
            className="growth-image"
          />
        ) : (
          <div className="no-stamps-message">
            スタンプを押して花を育てましょう
          </div>
        )}

        {/* 進捗表示 */}
        <div className="progress-display">
          <div className="progress-text">
            {stampCount}/100 の花が咲きました
          </div>
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${(stampCount / maxStamps) * 100}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}